// extracted by mini-css-extract-plugin
export default {"invoice_totals":"style_invoice_totals__pLVbX","certificate-border1":"style_certificate-border1__ijwHU"};